import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { KeycloakService } from '@core/services/auth/keycloak.service';

@Injectable({
  providedIn: 'root',
})
export class AuthSsoGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly keycloakService = inject(KeycloakService);

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const authenticated = await this.keycloakService.isAuthenticated();

    if (authenticated) {
      return true;
    } else {
      try {
        await this.keycloakService.getKeyCloakInstance().login({
          redirectUri: window.location.origin + state.url,
        });
        return false;
      } catch (error) {
        console.error('Keycloak login failed', error);
        return this.router.parseUrl('/error');
      }
    }
  }
}
